import React, { useState, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Button,
    Carousel,
    CarouselItem,
    CarouselIndicators,
} from "reactstrap";
import Axios from "axios";

// Import Navbar, Header, Footer components
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import CareerPageHeader from "../../components/Headers/CareerPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

// Import FontAwesome CSS for icons
import "@fortawesome/fontawesome-free/css/all.min.css";

const CareerPage = () => {
    const [data, setData] = useState(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const [animating, setAnimating] = useState(false);

    useEffect(() => {
        // Adding classes to body for layout consistency
        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        fetchCareerData();

        return () => {
            // Cleanup the classes when the component is unmounted
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    const fetchCareerData = async () => {
        try {
            const response = await Axios.get(`${process.env.REACT_APP_API_URL}/career/readCareer`);
            setData(response.data[0]); // Assuming you get an array and need the first element
        } catch (error) {
            console.error("Error fetching Career data:", error);
        }
    };

    if (!data) {
        return <div>Loading...</div>;
    }

    const {
        penjelasan,
        foto_1,
        foto_2,
        foto_3,
        foto_4,
        foto_5,
        foto_6,
        link_web,
        link_yt,
        link_ig,
    } = data;

    const images = [foto_1, foto_2, foto_3, foto_4, foto_5, foto_6].filter(Boolean);

    const onExiting = () => setAnimating(true);
    const onExited = () => setAnimating(false);

    const next = () => {
        if (animating) return;
        const nextIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
        setActiveIndex(nextIndex);
    };

    const previous = () => {
        if (animating) return;
        const nextIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
        setActiveIndex(nextIndex);
    };

    const goToIndex = (newIndex) => {
        if (animating) return;
        setActiveIndex(newIndex);
    };

    return (
        <>
            {/* Navbar */}
            <ExamplesNavbar />
            {/* Page Header */}
            <CareerPageHeader />
            {/* Main Content */}
            <div className="wrapper">
                <section className="uts">
                    <Container className="container-uts">
                        <Row className="my-4">
                            <Col>
                                <h2 className="text-center">Berkarir Di YKBUT</h2>
                                <p>{penjelasan}</p>
                            </Col>
                        </Row>

                        {/* Carousel Section */}
                        <Row className="justify-content-center">
                            <Col lg="6" md="10">
                                <Carousel activeIndex={activeIndex} next={next} previous={previous}>
                                    <CarouselIndicators
                                        items={images}
                                        activeIndex={activeIndex}
                                        onClickHandler={goToIndex}
                                    />
                                    {images.map((image, index) => (
                                        <CarouselItem
                                            onExiting={onExiting}
                                            onExited={onExited}
                                            key={index}
                                        >
                                            <img
                                                src={image}
                                                alt={`Slide ${index}`}
                                                className="img-fluid"
                                            />
                                            <div className="carousel-caption d-none d-md-block">
                                                <h5>Slide {index + 1}</h5>
                                            </div>
                                        </CarouselItem>
                                    ))}
                                    <a
                                        className="carousel-control-prev"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            previous();
                                        }}
                                        role="button"
                                    >
                                        <i className="now-ui-icons arrows-1_minimal-left"></i>
                                    </a>
                                    <a
                                        className="carousel-control-next"
                                        href="#pablo"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            next();
                                        }}
                                        role="button"
                                    >
                                        <i className="now-ui-icons arrows-1_minimal-right"></i>
                                    </a>
                                </Carousel>
                            </Col>
                        </Row>

                        {/* Social media links with icons */}
                        <Row className="link-container justify-content-center">
                            <Col xs="auto">
                                <Button
                                    color="primary"
                                    href={link_web}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fas fa-globe"></i>
                                </Button>
                            </Col>
                            <Col xs="auto">
                                <Button
                                    color="danger"
                                    href={link_yt}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-youtube"></i>
                                </Button>
                            </Col>
                            <Col xs="auto">
                                <Button
                                    color="warning"
                                    href={link_ig}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <i className="fab fa-instagram"></i>
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </section>

                {/* Footer */}
                <DefaultFooter />
            </div>
        </>
    );
};

export default CareerPage;
